import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAdminSecret } from "@/hooks/useAdminSecret";
import { api } from "@/lib/api";

export default function Footer() {
  const { longPressHandlers } = useAdminSecret();
  const [visits, setVisits] = useState(null);

  useEffect(() => {
    api.get("/visits").then((r) => setVisits(r.data.count)).catch(() => {});
  }, []);

  return (
    <footer className="border-t border-black/5 bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div
            className="flex items-center gap-2 cursor-pointer select-none"
            data-testid="footer-logo"
            {...longPressHandlers}
          >
            <span className="text-[#B8860B] font-display text-3xl">✟</span>
            <div>
              <div className="font-display text-xl text-[#1A1A1A]">Refuge de la Foi</div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-[#6B6B6B] mt-1">
                Là où la grâce devient parure
              </div>
            </div>
          </div>
          <p className="mt-6 text-sm text-[#6B6B6B] leading-relaxed font-citation italic max-w-xs">
            {`"Car je n'ai point honte de l'Évangile : c'est une puissance de Dieu pour le salut de quiconque croit."`}
            <span className="block mt-2 not-italic text-xs tracking-[0.2em] text-[#B8860B]">— ROMAINS 1:16</span>
          </p>
        </div>

        <div>
          <h4 className="label-tiny mb-4">Navigation</h4>
          <ul className="space-y-2 text-sm text-[#1A1A1A]/85">
            <li><Link to="/" className="hover:text-[#B8860B]">Accueil</Link></li>
            <li><Link to="/catalogue" className="hover:text-[#B8860B]">Catalogue</Link></li>
            <li><Link to="/contact" className="hover:text-[#B8860B]">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="label-tiny mb-4">Contact</h4>
          <ul className="space-y-2 text-sm text-[#1A1A1A]/85">
            <li>WhatsApp : +225 07 11 69 31 61</li>
            <li>{`Abidjan, Côte d'Ivoire`}</li>
            <li>Livraison sous 24h</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-black/5 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 px-6 max-w-7xl mx-auto">
        <div className="text-xs text-[#6B6B6B] tracking-[0.2em] uppercase">
          © {new Date().getFullYear()} Refuge de la Foi
        </div>
        <div
          className="text-xs tracking-[0.2em] uppercase text-[#B8860B] flex items-center gap-2"
          data-testid="visitor-counter"
        >
          <span className="inline-block w-2 h-2 bg-[#B8860B] rounded-full animate-pulse" />
          {visits !== null ? new Intl.NumberFormat("fr-FR").format(visits) : "…"} visites
        </div>
      </div>
    </footer>
  );
}
